import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-pcomp-material-design-icon-colours',
	templateUrl:'./MaterialDesignIconColoursPluginCompPage.html',
	styles: [],
	styleUrls:['./MaterialDesignIconColoursPluginCompPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class MaterialDesignIconColoursPluginCompPage
{
	mdContent_1062 = `\`\`\`java
import com.jwebmp.plugins.materialdesignicons.MaterialDesignIconColours;
\`\`\``;
}
